<template>
    <div id="customerAccount">
        <el-form ref="searchForm" :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="代理商名称：">
                <el-input v-model.trim="searchForm.name"  @keyup.enter.native="getAccountListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="代理商账号：">
                <el-input v-model.trim="searchForm.sysUserAccountName" @keyup.enter.native="getAccountListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getAccountListPageHandle">搜 索</el-button>
                <el-button type="primary" @click="exportInfoHandle()">导 出</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border height="611">
            <el-table-column prop="name" label="代理商名称 "></el-table-column>
            <el-table-column prop="pathNames" label="层级关系"></el-table-column>
            <el-table-column prop="sysUserAccountName" label="代理商账号"></el-table-column>
            <el-table-column prop="bankName" label="开户行名称"></el-table-column>
            <el-table-column prop="subbranch" label="开户行支行名称"></el-table-column>
            <el-table-column prop="bankCardNo" label="银行卡号"></el-table-column>
            <el-table-column prop="accountName" label="开户名"></el-table-column>
            <el-table-column prop="idCard" label="身份证号"></el-table-column>
            <el-table-column prop="bindMobile" label="预留手机号"></el-table-column>
            <el-table-column prop="alipayAccount" label="支付宝账号"></el-table-column>
            <el-table-column prop="createTime" label="新建时间" width="140"></el-table-column>
            <el-table-column prop="updateTime" label="操作时间" width="140"></el-table-column>
            <el-table-column label="操作" width="80">
                <template slot-scope="scope">                    
                    <el-button type="text" size="small"  @click="resetPwdHandle(scope.row.sysUserId)">重置密码</el-button>
                </template>
            </el-table-column>
        </el-table>
        

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 


    </div>
</template>

<script>
import {getAgentAccountListPage, exportCollectAgentList, } from '@/api/customers.js'
import {resetUserPwd} from '@/api/user.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                name: '',
                sysUserAccountName: '',
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },

        }
    },
    methods: {

        resetPwdHandle(id){
            resetUserPwd({'id': id}).then(res => {
                this.$message.success(res.data.message)
            })
        },

        getAccountListPageHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getAgentAccountListPage(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },

        exportInfoHandle(){
            let _that = this;
            common.deleteSpaceKey(_that.searchForm); 

            this.$confirm('确定导出吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                exportCollectAgentList(_that.searchForm).then(res =>{
                    if(res.data.code == 200){
                        this.$message.success('数据导出中,请稍候去下载专区下载');
                    }else{
                        this.$message.error(res.data.msg);
                    }
                }).catch(err=>console.error(err));
            }).catch(() => {

            });
        },

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAccountListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAccountListPageHandle();
        }  
    },
    created () {
        this.getAccountListPageHandle();
    }  
}
</script>

<style lang="less" scoped>

#customerAccount{
    .uploadFile{
        opacity: 0;
        height: 32px;
    }

    .toChooseFileBtn{
        position: absolute;
        left: 0;
        top: 0;
        background: none;
        border: 1px solid #DCDFE6;
        color: #606266;
        width: 80px;
        height: 32px;
        border-radius: 5px;
        text-align: center;
        font-size: 12px;
    }
}

</style>

